import * as React from 'react';
import { withRouteData } from 'react-static';

import { PrivacyPageLocale } from '../../components/PrivacyPage/privacyPage.locale';
import PrivacyPageComponent from '../../components/PrivacyPage/PrivacyPage';

interface PrivacyPageProp {
  locale: PrivacyPageLocale;
}

const PrivacyPage: React.SFC<PrivacyPageProp> = ({ locale }) => (
  <PrivacyPageComponent locale={locale} />
);

export default withRouteData(PrivacyPage);



// WEBPACK FOOTER //
// /www/client/src/containers/PrivacyPage/PrivacyPage.tsx